type AdminTopbarProps = {
  /** Controle à esquerda da trilha/título (toggle do menu lateral). */
  leading?: React.ReactNode;
  /** Trilha curta acima do título (ver `BreadcrumbTrail`). */
  crumb?: React.ReactNode;
  title: React.ReactNode;
  /** Botão areia da direita ("Adicionar"). */
  action?: React.ReactNode;
};

/**
 * Topo sticky de 76px com blur. A trilha fica ACIMA do título, em 10.5px caixa alta;
 * o título é Barlow 800 em 24px caixa alta. Nada de título no meio de card.
 */
export const AdminTopbar: React.FC<AdminTopbarProps> = ({
  leading,
  crumb,
  title,
  action,
}) => (
  <header className="sticky top-0 z-20 border-b border-border bg-background/85 backdrop-blur-xl">
    <div className="flex h-[76px] items-center gap-4 px-5 md:px-8">
      {leading}
      <div className="mr-auto flex min-w-0 flex-col gap-1.5">
        {crumb}
        {/* Celular: até 2 linhas em 20px em vez de cortar em 1 ("ALIST…"). */}
        <h1 className="font-display m-0 text-2xl font-extrabold uppercase leading-none tracking-tight text-white max-sm:line-clamp-2 max-sm:text-xl max-sm:leading-[1.05] sm:truncate">
          {title}
        </h1>
      </div>

      {action}
    </div>
  </header>
);
